module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "moverequirementmodal",
    attrs: {
      "id": _vm.modalId,
      "name": "move-requirement-modal",
      "title": _vm.requirements.length > 1 ? ("Move " + (_vm.requirements.length) + " requirements") : 'Move requirement',
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Move",
      "close-title": "Cancel",
      "hide-header-close": "",
      "ok-disabled": !_vm.selectedFolder
    },
    on: {
      "shown": _vm.shown,
      "ok": _vm.handleOk,
      "cancel": _vm.handleCancel
    }
  }, [_c('folders-list', {
    attrs: {
      "folders": _vm.folders
    }
  }), _vm._v(" "), (_vm.selectedFolder && _vm.requirements.length === 1) ? _c('span', [_vm._v("This requirement will be moved to "), _c('strong', [_vm._v(_vm._s(_vm.selectedFolder.name))])]) : (_vm.selectedFolder && _vm.requirements.length > 1) ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm.requirements.length))]), _vm._v(" requirements will be moved to "), _c('strong', [_vm._v(_vm._s(_vm.selectedFolder.name))])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Moving\n  ")], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dc04b60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/MoveRequirementModal.vue
// module id = 1008
// module chunks = 1